import React, { ReactNode, cloneElement } from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  button?: ReactNode;
  buttonTarget?: () => void;
  copy?: string;
  buttonCopy?: string;
  title?: string;
  icon?: React.ReactNode;
}

export function EmptyState({
  button,
  buttonTarget,
  copy = "No items found. Get started now!",
  buttonCopy = "Add new item",
  title = "No items found",
  icon,
}: EmptyStateProps) {
  const { t } = useTranslation();

  const defaultIcon = (
    <Calendar className="size-12 text-primary-light" aria-hidden="true" />
  );
  const sizedIcon = icon
    ? cloneElement(icon as React.ReactElement<{ className?: string }>, {
        className: "size-12",
      })
    : defaultIcon;

  return (
    <div
      className="flex h-[320px] flex-col items-center justify-center p-8"
      role="region"
      aria-label={t("dataTable.emptyState")}
    >
      <div className="h-12 w-12 text-muted-foreground">{sizedIcon}</div>
      <h2 className="sr-only mt-8">{title}</h2>
      <p
        className="mt-8 w-[241px] text-center text-wrap text-muted-foreground"
        role="status"
      >
        {copy}
      </p>
      {button
        ? button
        : buttonTarget && (
            <Button
              onClick={buttonTarget}
              variant="default"
              className="mt-8 h-10 bg-green-700 hover:bg-green-800"
              aria-label={`${buttonCopy} - ${copy}`}
            >
              {buttonCopy}
            </Button>
          )}
    </div>
  );
}
